import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { EModelName } from './model-name';

const PodcastSchema = new mongoose.Schema({
  user: { type: mongoose.Schema.Types.ObjectId, ref: EModelName.USER },
  type: { type: String },
  title: { type: String },
  chapter: { type: String },
  url: { type: String },
  transcript: { type: String },
  audioDuration: { type: Number },
  sharableToken: { type: String },
  created: { type: Date, default: Date.now() },
});

export type T_PodcastBase = InferSchemaType<typeof PodcastSchema>;

// Extend the type to provide proper typing for podcast type
export interface T_Podcast extends Omit<T_PodcastBase, 'type'> {
  type: 'weekly' | 'daily';
}

export type T_PodcastDocument = T_Podcast &
  Document & {
    _id: string;
  };

export { PodcastSchema };
